import { Button, Checkbox, Col, Form, Input, Row, Tooltip } from 'antd';
import React, { ReactElement, useContext, useEffect, useState } from 'react';
import {
  COMMON_ERROR, CONFIGURATION_VALIDATIONS, EMAIL_REGX, EXCHANGE_URL, GUTTOR_SPACE, HOSPITAL_MAILBOX_CONGURATIONS,
  HTTP_EXCEPTION, MAIL_CONFIG, MICROSOFT_EXCHANGE_URL,
  OTHER_KEY,
  PASSWORD_TYPES,
} from '../../../shared/constants/commonConstants';
import { FormSelect, FormTextInput } from '../../../shared/components/crmFormElement/FormInput';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { MailboxType } from '../../../store/models/mailBoxModel';
import {
  fetchHospitalConfig, saveDepartmentEmailConfig, saveHospitalPrimaryMailId,
  saveHospitalSecondaryMailId,
} from '../../../store/actions/mailBoxAction';
import { centeredNotification, validateEmails } from '../../../utils/utility';
import { ReactComponent as DeleteIcon } from '../../../assets/images/svg/delete-icon.svg';
import { ReactComponent as AddIcon } from '../../../assets/images/svg/Add-icon.svg';
import { ReactComponent as EditIcon } from '../../../assets/images/svg/Edit-icon.svg';
import FormInputPassword from '../../../shared/components/crmFormElement/FormInputPassword/FormInputPassword';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';
import { REDIRECT_URL_CONF } from '../../../shared/constants/crmConstants';
import CustomTag from '../../../shared/components/customTag/customTag';
import { customGTMEvent, validateEmailField } from '../../crm/inPatient/service/crmUtils';
import { CenterContext } from '../../crm/inPatient/newAdmission/CenterContext';
import FormMultiEmailInput from '../../../shared/components/crmFormElement/FormMultiEmailInput/FormMultiEmailInput';

const RpaConfiguredPayerList = (): ReactElement => {

  const [hospitalForm] = Form.useForm();
  const [secondaryForm] = Form.useForm();
  const [otherTeamForm] = Form.useForm();

  const [configType, setConfigType] = useState('');
  const [counter, setCounter] = React.useState(0);
  const appDetail = ApplicationDetail.instance;
  const groupProviders = appDetail?.getGroupProviders();
  const { hospitalConfiguration: emailConfig = {} as any, centerId } =
    useSelector((state: RootState): MailboxType => state?.mailBox || {});
  const [emailConfiguration, setEmailConfiguration] = useState(emailConfig);
  const [enabledRows, setEnabledRows] = useState<boolean[]>([]);
  const [showEditPrimary, setIsEditPrimary] = useState(true);
  const [showEmailField, setIsShowEmailField] = useState<boolean>();
  const [showSecondaryEmailField, setIsSecondaryShowEmailField] = useState<boolean>();
  const [showOtherTeamField, setIsOtherTeamField] = useState<boolean>();
  const [showEditDept, setIsShowEditDept] = useState(true);
  const [hospSecondaryEmails, setHospSecondaryEmails] = useState([] as any);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const centerContext = useContext(CenterContext);

  useEffect((): any => {
    dispatch(fetchHospitalConfig((groupProviders?.length && centerId) ?
      centerContext?.center : appDetail.getProviderId(), onSuccessFetchHospitalConfig, (): any => { }));
  }, [centerContext?.center]);

  const onSuccessFetchHospitalConfig = (hospConfig: any): any => {
    if (hospConfig) {
      setEmailConfiguration(hospConfig);
    }
  };
  const isGroupLogin = (): boolean => {
    if (groupProviders?.length && centerId) {
      return true;
    } else {
      return !groupProviders?.length; // Return true if it's not a group login, otherwise false
    }
  };
  useEffect((): any => {
    if (isGroupLogin()) {
      setInitialPrimaryMailCreds();
      setInitialSecondaryEmail();
      setInitialHospDeptEmail();
      setIsEditPrimary((typeof emailConfiguration?.hospitalPrimaryMailID === 'string' &&
        emailConfiguration?.hospitalPrimaryMailID?.length) ? true : false);
      setIsShowEmailField(Boolean(emailConfiguration?.hospitalPrimaryMailID?.length));
      setIsSecondaryShowEmailField(Boolean(emailConfiguration?.hospitalSecondaryMailIds?.length));
      setIsOtherTeamField(Boolean(emailConfiguration?.hospitalDepartments?.length));
      setIsShowEditDept(emailConfiguration?.hospitalDepartments?.length > 0 ? true : false);
    } else {
      if (isGroupProvidersAvailable()) {
        hospitalForm?.resetFields();
        secondaryForm?.resetFields();
        otherTeamForm?.resetFields();
        setIsShowEmailField(false);
        setIsSecondaryShowEmailField(false);
        setIsOtherTeamField(false);
      }
    }
  }, [emailConfiguration, emailConfig]);

  const isGroupProvidersAvailable = (): boolean => {
    return groupProviders?.length && centerId === 0;
  };

  const setInitialPrimaryMailCreds = (): any => {
    hospitalForm?.resetFields();
    setConfigType('');
    const { incomingMailServerHostName, incomingMailServerPort, configurationType, passwordType } = emailConfiguration || {};
    let configurationBy = configurationType ? configurationType : undefined;
    if (typeof emailConfiguration?.hospitalPrimaryMailID === 'string' &&
      emailConfiguration?.hospitalPrimaryMailID?.length && configurationBy === undefined) {
      if (
        incomingMailServerHostName === 'smtp.gmail.com' &&
        incomingMailServerPort === 993
      ) {
        configurationBy = 'gmailWithPass';
      } else if (
        incomingMailServerHostName === 'outlook.office365.com' &&
        incomingMailServerPort === 993
      ) {
        configurationBy = 'outlook';
      } else if (
        incomingMailServerHostName === 'outlook.office365.com' &&
        incomingMailServerPort === 995
      ) {
        configurationBy = 'hotmail';
      } else if (passwordType === 'MSExchange') {
        configurationBy = 'microsoftExchange';
      } else if (passwordType === 'SendGrid') {
        configurationBy = 'sendGrid';
      } else {
        configurationBy = OTHER_KEY;
      }
    }
    //  else if (passwordType === 'GmailAccessToken') {
    //   configurationBy = 'gmail';
    // }
    // localStorage.setItem('mailBoxConfiguredRohiniId', mailBoxConfiguredRohiniId);
    hospitalForm.setFieldsValue({
      ['hospitalPrimaryMailID']: emailConfiguration?.hospitalPrimaryMailID,
      ['hospitalPrimaryMailPassword']: emailConfiguration?.hospitalPrimaryMailPassword,
      ['enableSSL']: true,
      ['configurationType']: configurationBy,
      ['microsoftExchange']: emailConfiguration?.exchangeUrl?.replace(HTTP_EXCEPTION, ''),
    });
    // This ensures we use the latest form state, as getFieldValue returns stale data if called before setting the value
    //  or fallback to configurationType
    const configurationByType = hospitalForm?.getFieldValue('configurationType') || configurationType;
    if (configurationByType === OTHER_KEY) {
      hospitalForm.setFieldsValue({
        ['incomingMailServerHostName']: emailConfiguration?.incomingMailServerHostName,
        ['incomingMailServerPort']: emailConfiguration?.incomingMailServerPort,
        ['outGoingMailServerHostName']: emailConfiguration?.outGoingMailServerHostName,
        ['outGoingMailServerPort']: emailConfiguration?.outGoingMailServerPort,
      });
    }
    setConfigType(configurationBy);
  };

  const setInitialSecondaryEmail = (): any => {
    if (!emailConfiguration?.hospitalSecondaryMailIds?.length) {
      setIsSecondaryShowEmailField(false);
    }
    secondaryForm?.resetFields();
    setHospSecondaryEmails(emailConfiguration?.hospitalSecondaryMailIds?.split(','));
  };

  const setInitialHospDeptEmail = (): any => {
    setCounter(emailConfiguration?.hospitalDepartments?.length > 0 ? emailConfiguration?.hospitalDepartments?.length - 1 : 0);
    otherTeamForm?.resetFields();
    emailConfiguration?.hospitalDepartments?.forEach((otherTeam: any, index: number): any => {
      otherTeamForm.setFieldsValue({
        [`departmentId_${index}`]: otherTeam?.departmentId,
        [`departmentEmail_${index}`]: otherTeam?.departmentEmail,
      });
    });
  };

  useEffect((): any => {
    getOtherTeamEmailRows();
  }, [counter]);

  const saveHospitalPrimaryId = async (): Promise<void> => {
    try {
      await hospitalForm.validateFields();
      const formData = hospitalForm.getFieldsValue();
      formData.isHospitalPrimaryMailIdExists = true;

      if (formData.hospitalPrimaryMailID && formData.hospitalPrimaryMailPassword && !emailConfiguration.hospitalPrimaryMailID) {
        formData.isHospitalPrimaryMailIdExists = false;
      }

      if (!formData.incomingMailServerPort || !formData.outGoingMailServerPort) {
        formData.incomingMailServerPort = 0;
        formData.outGoingMailServerPort = 0;
      }

      const {
        hospitalPrimaryMailID, hospitalPrimaryMailPassword, hospitalSecondaryMailIds, isHospitalPrimaryMailIdExists, incomingMailServerPort,
        outGoingMailServerHostName, outGoingMailServerPort, incomingMailServerHostName, enableSSL, rohiniID, code = '', configurationType,
        microsoftExchange,
      } = formData;

      let request = {} as any;
      if (hospitalPrimaryMailID) {
        customGTMEvent({
          event: 'Primary Email Configuration',
        });
        if (configurationType === 'gmail') {
          request = {
            gmailAuthorizationCode: code,
            redirectUri: REDIRECT_URL_CONF.GMAIL,
            delayPressCount: null,
            delayDate: null,
            rohiniID,
          };
        } else if (configurationType === 'outlook') {
          request = {
            hospitalPrimaryMailID,
            hospitalPrimaryMailPassword,
            hospitalSecondaryMailIds,
            isHospitalPrimaryMailIdExists,
            incomingMailServerHostName: MAIL_CONFIG[1]?.IncomingMailServerHost,
            incomingMailServerPort: Number(MAIL_CONFIG[1]?.IncomingMailServerPort),
            outGoingMailServerHostName: MAIL_CONFIG[1]?.OutgoingMailServerHost,
            outGoingMailServerPort: Number(MAIL_CONFIG[1]?.OutgoingMailServerPort),
            enableSSL: (enableSSL === undefined) ? true : enableSSL,
            rohiniID,
          };
        } else if (configurationType === 'gmailWithPass') {
          request = {
            hospitalPrimaryMailID,
            hospitalPrimaryMailPassword,
            hospitalSecondaryMailIds,
            isHospitalPrimaryMailIdExists,
            incomingMailServerHostName: MAIL_CONFIG[0]?.IncomingMailServerHost,
            incomingMailServerPort: Number(MAIL_CONFIG[0]?.IncomingMailServerPort),
            outGoingMailServerHostName: MAIL_CONFIG[0]?.OutgoingMailServerHost,
            outGoingMailServerPort: Number(MAIL_CONFIG[0]?.OutgoingMailServerPort),
            enableSSL: (enableSSL === undefined) ? true : enableSSL,
            rohiniID,
          };
        } else if (configurationType === 'hotmail') {
          request = {
            hospitalPrimaryMailID,
            hospitalPrimaryMailPassword,
            hospitalSecondaryMailIds,
            isHospitalPrimaryMailIdExists,
            incomingMailServerHostName: MAIL_CONFIG[2]?.IncomingMailServerHost,
            incomingMailServerPort: Number(MAIL_CONFIG[2]?.IncomingMailServerPort),
            outGoingMailServerHostName: MAIL_CONFIG[2]?.OutgoingMailServerHost,
            outGoingMailServerPort: Number(MAIL_CONFIG[2]?.OutgoingMailServerPort),
            enableSSL: (enableSSL === undefined) ? true : enableSSL,
            rohiniID,
          };
        } else if (configurationType === 'microsoftExchange') {
          request = {
            hospitalPrimaryMailID,
            hospitalPrimaryMailPassword,
            hospitalSecondaryMailIds,
            isHospitalPrimaryMailIdExists,
            incomingMailServerHostName: MAIL_CONFIG[3]?.IncomingMailServerHost,
            incomingMailServerPort: Number(MAIL_CONFIG[3]?.IncomingMailServerPort),
            outGoingMailServerHostName: MAIL_CONFIG[3]?.OutgoingMailServerHost,
            outGoingMailServerPort: Number(MAIL_CONFIG[3]?.OutgoingMailServerPort),
            enableSSL: (enableSSL === undefined) ? true : enableSSL,
            exchangeUrl: microsoftExchange,
            rohiniID,
          };
        } else {
          request = {
            hospitalPrimaryMailID,
            hospitalPrimaryMailPassword,
            hospitalSecondaryMailIds,
            isHospitalPrimaryMailIdExists,
            incomingMailServerHostName,
            incomingMailServerPort: parseInt(incomingMailServerPort, 10),
            outGoingMailServerHostName,
            outGoingMailServerPort: parseInt(outGoingMailServerPort, 10),
            enableSSL,
            rohiniID,
          };
        }
      }
      // handling exchange url matching the exact pattern of MS Exchange URL
      if (request?.exchangeUrl) {
        const MSUrl = request?.exchangeUrl?.toLowerCase();
        if (MSUrl?.endsWith(EXCHANGE_URL?.toLowerCase())) {
          request.exchangeUrl = request?.exchangeUrl?.includes(EXCHANGE_URL)
            ? request?.exchangeUrl
            : request?.exchangeUrl?.replace(/\/ews.*/i, EXCHANGE_URL);
        } else {
          request.exchangeUrl = request?.exchangeUrl?.replace(/\/+$/, '') + EXCHANGE_URL;
        }
      }
      const data = {
        HospitalMailID: request?.hospitalPrimaryMailID,
        HospitalMailPassword: request?.hospitalPrimaryMailPassword,
        isHospitalPrimaryMailIdExists: request?.isHospitalPrimaryMailIdExists,
        incomingMailServerHostName: request?.incomingMailServerHostName,
        incomingMailServerPort: request?.incomingMailServerPort,
        outGoingMailServerHostName: request?.outGoingMailServerHostName,
        outGoingMailServerPort: request?.outGoingMailServerPort,
        enableSSL: request?.enableSSL,
        rohiniCode: rohiniID,
        providerId: groupProviders?.length && centerId ? centerContext?.center :
          appDetail?.getProviderId(),
        exchangeUrl: request?.exchangeUrl ? (HTTP_EXCEPTION + request?.exchangeUrl) : null,
        passwordType: configType ? PASSWORD_TYPES[configType] : null,
      };
      setLoading(true);
      dispatch(saveHospitalPrimaryMailId(data, onSuccessHospitalPrimaryId,
        (error: any): any => { centeredNotification(error || COMMON_ERROR); setLoading(false); }));
    } catch (error) {
      console.error(error);
    }
  };

  const configHandler = (event: any): any => {
    setConfigType(event);
    hospitalForm?.resetFields(['hospitalPrimaryMailID', 'hospitalPrimaryMailPassword', 'microsoftExchange']);
  };

  const onSuccessHospitalPrimaryId = (): any => {
    dispatch(fetchHospitalConfig(appDetail?.getProviderId()));
    setLoading(false);
    const { hospitalPrimaryMailID, hospitalPrimaryMailPassword, enableSSL, configurationType,
      isHospitalPrimaryMailIdExists, incomingMailServerHostName, incomingMailServerPort, outGoingMailServerHostName,
      outGoingMailServerPort } = hospitalForm.getFieldsValue(['hospitalPrimaryMailID',
        'hospitalPrimaryMailPassword', 'enableSSL', 'configurationType', 'isHospitalPrimaryMailIdExists',
        'incomingMailServerHostName', 'incomingMailServerPort', 'outGoingMailServerHostName', 'outGoingMailServerPort']);
    let { microsoftExchange } = hospitalForm.getFieldsValue(['microsoftExchange']);
    // handling exchange url matching the exact pattern of MS Exchange URL before prefilling in the field
    if (microsoftExchange) {
      const MSUrl = microsoftExchange?.toLowerCase();
      if (MSUrl?.endsWith(EXCHANGE_URL?.toLowerCase())) {
        microsoftExchange = microsoftExchange?.includes(EXCHANGE_URL)
          ? microsoftExchange
          : microsoftExchange?.replace(/\/ews.*/i, EXCHANGE_URL);
      } else {
        microsoftExchange = microsoftExchange?.replace(/\/+$/, '') + EXCHANGE_URL;
      }
    }
    const updatedConfig = {
      ...emailConfiguration, hospitalPrimaryMailID, hospitalPrimaryMailPassword, configurationType, enableSSL,
      isHospitalPrimaryMailIdExists, incomingMailServerHostName, incomingMailServerPort, outGoingMailServerHostName,
      outGoingMailServerPort, exchangeUrl: microsoftExchange,
    };
    setEmailConfiguration(updatedConfig);
    setIsEditPrimary(true);
  };

  const onCancelHospitalPrimary = (): void => {
    setLoading(false);
    if (emailConfiguration?.hospitalPrimaryMailID?.length) {
      setIsEditPrimary(true);
      setInitialPrimaryMailCreds();
    } else {
      setIsShowEmailField(false);
    }
  };

  const hospSecondaryEmailApiCall = (emails: any): void => {
    const finalEmail = emails ? String(emails) : null;
    const updatedConfig = { ...emailConfiguration, hospitalSecondaryMailIds: finalEmail };
    dispatch(saveHospitalSecondaryMailId(finalEmail, (): any => {
      setEmailConfiguration(updatedConfig);
    },
      (errMsg: any): any => { centeredNotification(errMsg || COMMON_ERROR); }));
  };

  const saveHospitalSecondaryId = async (): Promise<void> => {
    const emailFormObj = await secondaryForm?.validateFields();
    let emails = validateEmails(emailFormObj?.['secondaryemail'], hospSecondaryEmails);
    if (emails?.length) {
      if (hospSecondaryEmails?.length) {
        emails = emails?.concat(',', hospSecondaryEmails?.toString());
      }
      hospSecondaryEmailApiCall(emails);
    }
    customGTMEvent({
      event: 'Secondary Email Configuration',
    });
  };

  const onRemoveHospSecondaryEmail = (removedEmail: any): any => {
    const finalEmails = hospSecondaryEmails?.filter((email: any): any => email !== removedEmail);
    hospSecondaryEmailApiCall(finalEmails?.length ? finalEmails : null);
  };

  const onSaveHospitalDepartment = async (indexRow: any): Promise<void> => {
    setIsOtherTeamField(true);
    const deptId = otherTeamForm?.getFieldsValue()?.[`departmentId_${indexRow}`];
    const deptMail = otherTeamForm?.getFieldsValue()?.[`departmentEmail_${indexRow}`];
    const emailMatch = EMAIL_REGX?.test(deptMail);
    const otherTeamFormValue = otherTeamForm?.getFieldsValue();
    const otherTeamFormValueArray: { [x: string]: any; }[] = [];
    Object.keys(otherTeamFormValue)?.forEach((key: any): any => {
      const index = key?.match(/\d+/);
      const property = key?.replace(/\_\d+/, '');
      const value = otherTeamFormValue?.[key];
      if (index !== null) {
        const currentIndex = parseInt(index[0], 10);
        if (!otherTeamFormValueArray[currentIndex]) {
          otherTeamFormValueArray[currentIndex] = {};
        }
        otherTeamFormValueArray[currentIndex][property] = value;
      }
    });
    const payload = {
      providerId: groupProviders?.length && centerId ? centerContext?.center :
        appDetail?.getProviderId(),
      payerId: 0,
      hospitalDepartments: [{ ...otherTeamFormValueArray[indexRow], isDeleted: false }],
    };
    const updatedConfig = { ...emailConfiguration, hospitalDepartments: otherTeamFormValueArray };
    if (deptId !== undefined && emailMatch) {
      dispatch(saveDepartmentEmailConfig(payload, (): any => {
        setIsShowEditDept(true);
        dispatch(fetchHospitalConfig(appDetail?.getProviderId()));
        setIsOtherTeamField(false); setEmailConfiguration(updatedConfig);
        setEnabledRows((prevEnabledRows: any): any => {
          const updatedEnabledRows = [...prevEnabledRows];
          updatedEnabledRows[indexRow] = false; // Disable the corresponding index value
          return updatedEnabledRows;
        });
        customGTMEvent({
          event: 'Team Email Configuration',
        });
      },
        (error: any): any => { centeredNotification(error); }));
    } else {
      otherTeamForm?.validateFields();
    }
  };

  const removeHospitalDept = (indexToRemove: number): void => {
    const formValues: Record<string, any> = otherTeamForm?.getFieldsValue();
    customGTMEvent({
      event: 'Delete Team Email',
    });
    const transformedArray = Object?.keys(formValues)?.reduce((result: any, key: any): any => {
      const [field, index] = key?.split('_');
      const value = formValues[key];

      if (!result[index]) {
        result[index] = {};
      }

      result[index][field] = value;

      return result;
    }, []);

    otherTeamForm?.setFieldsValue(transformedArray);
    const removedDepartment = emailConfiguration?.hospitalDepartments?.[indexToRemove];
    const updatedDepartments = transformedArray?.filter((_: any, index: number): any => index !== indexToRemove);
    const updatedConfig = {
      ...emailConfig, hospitalSecondaryMailIds: emailConfiguration?.hospitalSecondaryMailIds,
      hospitalDepartments: updatedDepartments,
    };
    setCounter((prevCounter: any): any => prevCounter - 1);
    setEmailConfiguration(updatedConfig);
    setEnabledRows((prevEnabledRows: any): any => {
      const updatedEnabledRows = [...prevEnabledRows];
      updatedEnabledRows?.splice(indexToRemove, 1);
      // Iterate through each object and check if any key value is undefined
      updatedDepartments?.forEach((obj: any, index: any): any => {
        const isDepartmentIdPresent = emailConfig?.hospitalDepartments?.some((dept: any): any => {
          if (dept?.departmentId === undefined || Object?.(obj)?.departmentId === undefined) {
            return false;  // Make isDepartmentIdPresent false if either dept or obj is undefined
          }
          return dept?.departmentId === Object?.(obj)?.departmentId;
        });
        updatedEnabledRows[index] = !isDepartmentIdPresent;
      });
      return updatedEnabledRows;
    });
    const payload = {
      providerId: appDetail.getProviderId(),
      payerId: 0,
      hospitalDepartments: [{ ...removedDepartment, isDeleted: true }],
    };
    dispatch(saveDepartmentEmailConfig(payload, (): any => {
      // api call to store the updated dept data after saving
      dispatch(fetchHospitalConfig(appDetail?.getProviderId()));
    },
      (error: any): any => { centeredNotification(error); }));
  };

  const onCancelHospDept = (i: any): any => {
    toggleCancelDept(i);
    setIsShowEditDept(true);
  };

  const toggleCancelDept = (index: number): void => {
    // Update the enabledRows state based on the current index
    setEnabledRows((prevEnabledRows: boolean[]): boolean[] => {
      // Create a copy of the current enabledRows state
      const updatedEnabledRows = [...prevEnabledRows];
      // Retrieve the current department's configuration and form values
      const otherTeam = emailConfiguration.hospitalDepartments[index];
      const formValues = otherTeamForm.getFieldsValue();
      const formDepartmentId = formValues[`departmentId_${index}`];
      const formDepartmentEmail = formValues[`departmentEmail_${index}`];
      // Check if both department ID and email are undefined in the configuration and form
      const hasNoDepartmentDetails =
        (!otherTeam?.departmentId && !otherTeam?.departmentEmail) ||
        (!formDepartmentId && !formDepartmentEmail);
      // Filter out departments that have valid IDs or emails
      const filteredDepartments = emailConfiguration?.hospitalDepartments?.filter(
        (team: any): boolean => (team?.departmentId !== undefined || team?.departmentEmail !== undefined),
      );
      // If values are undefined and no valid departments exist, enable the row and disable the "Other Team" field
      if (hasNoDepartmentDetails && (!filteredDepartments?.length || emailConfig?.length)) {
        updatedEnabledRows[index] = true; // Enable the row
        setIsOtherTeamField(false); // Disable the "Other Team" field
      } else {
        if (hasNoDepartmentDetails) {
          // Adjust the counter to reflect the number of valid departments rendering thw rows
          setCounter(filteredDepartments?.length - 1);
        }
        // Reset the form fields to the current department's values
        otherTeamForm.setFieldsValue({
          [`departmentId_${index}`]: otherTeam?.departmentId,
          [`departmentEmail_${index}`]: otherTeam?.departmentEmail,
        });
        // Validate the email format using a regular expression
        const isSavedAndCorrect = EMAIL_REGX?.test(otherTeam?.departmentEmail);
        updatedEnabledRows[index] = !isSavedAndCorrect; // Enable the row if the email is invalid
        if (formDepartmentId) {
          // Check if the department ID exists in the email configuration
          const existsInEmailConfig = emailConfig?.hospitalDepartments?.some((item: any): boolean => {
            return item.departmentId === formDepartmentId;
          });
          if (!existsInEmailConfig) {
            // If the department ID does not exist, decrement the counter and reset the form fields
            setCounter((): any => {
              return Math.max(0, counter - 1);
            });
            otherTeamForm?.resetFields([`departmentId_${index}`, `departmentEmail_${index}`]);
            // If no departments exist in the configuration, disable the "Other Team" field and reset the counter
            if (!emailConfig?.hospitalDepartments?.length) {
              setIsOtherTeamField(false);
              setCounter(0);
            }
          }
        }
      }
      // Update the "Edit Department" state based on whether any rows are enabled
      setIsShowEditDept(!updatedEnabledRows?.some((enabled: any): boolean => enabled));
      // Return the updated enabledRows state
      return updatedEnabledRows;
    });
  };

  const toggleEditDept = (index: any): any => {
    setEnabledRows((prevEnabledRows: any): any => {
      const updatedEnabledRows = [...prevEnabledRows];
      if (!emailConfiguration?.hospitalDepartments?.length && index === 0) {
        updatedEnabledRows[index] = true;
        setIsOtherTeamField(false);
      } else {
        updatedEnabledRows[index] = !updatedEnabledRows[index];
      }
      customGTMEvent({
        event: 'Edit Team Email',
      });
      setIsShowEditDept(!updatedEnabledRows?.some((enabled: any): any => enabled));
      return updatedEnabledRows;
    });
  };

  const addHospDept = (index: any): any => {
    customGTMEvent({
      event: 'Add Team Email',
    });
    setEnabledRows((prevEnabledRows: any): any => {
      const updatedEnabledRows = [...prevEnabledRows];
      updatedEnabledRows[index] = !updatedEnabledRows?.[index];
      const otherTeam = emailConfiguration?.hospitalDepartments?.[index];
      const hasNoDepartmentDetails = otherTeam?.departmentId === undefined && otherTeam?.departmentEmail === undefined;
      if (index === counter && index < emailConfiguration?.allDepartments?.length - 1) {
        for (let i = 0; i <= counter; i++) {
          updatedEnabledRows[i] = false;
        }
        if ((!emailConfig?.hospitalDepartments?.length || hasNoDepartmentDetails) && index === 0) {
          updatedEnabledRows[index] = true;
        } else {
          updatedEnabledRows[index + 1] = true;
          setCounter(counter + 1);
        }
      }
      setIsShowEditDept(!updatedEnabledRows?.some((enabled: any): any => enabled));
      return updatedEnabledRows;
    });
  };
  const getOtherTeamEmailRows = (): any => {
    const otherTeamEmailRows: JSX.Element[] = [];
    const OtherTeamListOptions = emailConfiguration?.allDepartments?.map((option: any): any => {
      const isOptionSelected = emailConfig?.hospitalDepartments?.some((dept: any): any => {
        return option?.departmentId === dept?.departmentId;
      });
      return {
        name: option?.departmentName,
        value: option?.departmentId,
        disabled: isOptionSelected,
      };
    });

    for (let i = 0; i <= counter; i++) {
      otherTeamEmailRows?.push(
        <>
          <Row gutter={GUTTOR_SPACE} className="flex flex-row align-center">
            <Col md={6}>
              <FormSelect detail={{
                key: `departmentId_${i}`,
                options: OtherTeamListOptions,
                label: 'Department',
                placeholder: 'Select department',
                disabled: !enabledRows[i],
                allowOptionDisabled: true,
                isMaxLengthNotApplicable: true,
                required: true,
                hideLabel: true,
              }} />
            </Col>
            <Col md={9}>
              <FormTextInput detail={{
                key: `departmentEmail_${i}`,
                label: 'Department Email',
                placeholder: 'Enter communication email',
                disabled: !enabledRows[i],
                rules: [
                  {
                    validator: validateEmailField,
                  },
                ],
                hideLabel: true,
                isMaxLengthNotApplicable: true,
                required: true,
              }} />
            </Col>
            {(!enabledRows[i] && !showEditDept[i]) && <><Col className="no-pdg-rt">
              <EditIcon
                className="email-editbtn4"
                onClick={(): any => toggleEditDept(i)} />
            </Col>
              <Col className="pb-md mouse-pointer flex-element justify-center items-center no-pdg-rt padding-top-9"
                onClick={(): any => removeHospitalDept(i)}><DeleteIcon className="add-team-row-icon2" />
              </Col>
              {i === counter && i < OtherTeamListOptions?.length - 1 ?
                <Col className="pb-md mouse-pointer flex-element justify-center items-center padding-top-9"
                  onClick={(): any => addHospDept(i)}>
                  <AddIcon className="add-team-row-icon8" />
                </Col> : <></>
              }
            </>
            }
            <>
              {enabledRows[i] && <><Col className="pb-md-10 no-pdf-l">
                <a onClick={(): any => { otherTeamForm?.validateFields(); onSaveHospitalDepartment(i); }}
                  className="mouse-pointer bold">SAVE</a>
              </Col><Col onClick={(): any => { onCancelHospDept(i); }} className="pb-md-10 bold color-grey mouse-pointer other-dept">
                  <div>CANCEL</div>
                </Col></>}
            </>
          </Row>
        </>,
      );
    }
    return otherTeamEmailRows;
  };

  const configFields = {
    sendGrid: [
      {
        component: 'FormTextInput',
        key: 'hospitalPrimaryMailID',
        label: 'SendGrid App Key',
        hideLabel: true,
        required: false,
        isMaxLengthNotApplicable: true,
        placeholder: CONFIGURATION_VALIDATIONS?.sendGridAppKeyPlaceholder,
        rules: [
          { required: true, message: CONFIGURATION_VALIDATIONS?.sendGridValidation },
          { max: 50, message: CONFIGURATION_VALIDATIONS?.primaryMailIdCharValidation },
        ],
        disabled: showEditPrimary,
      },
      {
        component: 'FormInputPassword',
        key: 'hospitalPrimaryMailPassword',
        label: 'Password',
        placeholder: CONFIGURATION_VALIDATIONS?.sendGridPasswordPlaceholder,
        hideLabel: true,
        required: false,
        isMaxLengthNotApplicable: true,
        rules: [
          { required: true, message: CONFIGURATION_VALIDATIONS?.passwordValidation },
          { max: 70, message: CONFIGURATION_VALIDATIONS?.sendgridPasswordLimitValidation },
        ],
        disabled: showEditPrimary,
      },
    ],
    generic: [
      {
        component: 'FormTextInput',
        key: 'hospitalPrimaryMailID',
        label: 'Primary Email',
        placeholder: CONFIGURATION_VALIDATIONS?.primaryMailIdPlaceholder,
        hideLabel: true,
        required: false,
        isMaxLengthNotApplicable: true,
        rules: [
          { required: true, message: CONFIGURATION_VALIDATIONS?.primaryMailId },
          { max: 50, message: CONFIGURATION_VALIDATIONS?.primaryMailIdCharValidation },
          { pattern: EMAIL_REGX, message: CONFIGURATION_VALIDATIONS?.primaryMailIdPattern },
        ],
        disabled: showEditPrimary,
      },
      {
        component: 'FormInputPassword',
        key: 'hospitalPrimaryMailPassword',
        label: 'Password',
        placeholder: CONFIGURATION_VALIDATIONS?.primaryMailPasswordPlaceholder,
        hideLabel: true,
        required: false,
        isMaxLengthNotApplicable: true,
        rules: [
          { required: true, message: CONFIGURATION_VALIDATIONS?.passwordValidation },
          { max: 50, message: CONFIGURATION_VALIDATIONS?.passwordLimitValidation },
        ],
        disabled: showEditPrimary,
      },
    ],
  };

  // Dynamically render the form fields based on configType
  const renderFields = (fields: any): any => {
    return fields?.map((field: any): any => {
      switch (field.component) {
        case 'FormTextInput':
          return (
            <Col key={field?.key}>
              <FormTextInput detail={field} />
            </Col>
          );
        case 'FormInputPassword':
          return (
            <Col key={field?.key}>
              <FormInputPassword
                detail={{
                  ...field,
                  maxLength: (field?.maxLength || 50), // Default maxLength if not specified
                }}
              />
            </Col>
          );
        default:
          return null;
      }
    });
  };

  return (
    <>
      <div className="ant-tabs-content-holder tab-custom-container multipayer-tbl scroll bg-color-white w-100">
        <div className="claim-team flex flex-element flex-col">
          <Row className="w-30 font-weight-text flex flex-element flex-row align-center justify-between">
            <Col md={6}>
              <p className={`m-top-12 font-12 ${isGroupProvidersAvailable() ? 'disabled-text-color' : ''}`}>
                Claim Team</p>
            </Col>
            {!showEmailField &&
              <Col md={3}>
                <Button type="link" className={isGroupProvidersAvailable() ?
                  'buttontext mouse-pointer-default' : ''}
                  onClick={(): any => { isGroupLogin() && setIsShowEmailField(true); setIsEditPrimary(false); }}>
                  <i>Add email</i>
                </Button>
              </Col>
            }
          </Row>
          {showEmailField &&
            <><Row gutter={GUTTOR_SPACE} className="flex flex-row align-center m-top-12">
              <Form form={hospitalForm} onFinish={saveHospitalPrimaryId}>
                <Row gutter={GUTTOR_SPACE} className="row-container">

                  <Col className="w-18">
                    <FormSelect
                      detail={{
                        hideLabel: true,
                        key: 'configurationType',
                        placeholder: 'Client Email',
                        disabled: showEditPrimary,
                        onChange: (event: any): any => configHandler(event),
                        options: (HOSPITAL_MAILBOX_CONGURATIONS || []),
                        rules: [
                          {
                            required: true,
                            message: CONFIGURATION_VALIDATIONS?.configType,
                          },
                          {
                            max: 50,
                            message: CONFIGURATION_VALIDATIONS?.emailIdCharLimit,
                          },
                        ],
                      }} />
                  </Col>
                  {renderFields(configType === 'sendGrid' ? configFields[configType] : configFields.generic)}
                  <div className="claim-team">
                    {configType === OTHER_KEY && <>
                      <Row gutter={GUTTOR_SPACE} className="m-l-11">
                        <Col md={24} className="font-12 font-weight-text">
                          <strong>Incoming Mail Server</strong>
                        </Col>
                        <Col>
                          <Form.Item label="Hostname" name="incomingMailServerHostName" labelCol={{ span: 24 }} rules={[
                            {
                              required: true,
                              message: CONFIGURATION_VALIDATIONS?.fieldRequiredMessage,
                            },
                          ]}>
                            <Input type="text" disabled={showEditPrimary} placeholder="Incoming mail server address"
                              autoComplete="off" required={true} />
                          </Form.Item>
                        </Col><Col>
                          <Form.Item label="Port" name="incomingMailServerPort" labelCol={{ span: 24 }} rules={[
                            {
                              required: true,
                              message: CONFIGURATION_VALIDATIONS?.fieldRequiredMessage,
                            },
                          ]}>
                            <Input type="text" disabled={showEditPrimary} placeholder="Incoming server port"
                              autoComplete="off" required={true} />
                          </Form.Item>
                        </Col>
                        <Col md={24} className="font-12 font-weight-text">
                          <strong>Outgoing Mail Server</strong>
                        </Col><Col>
                          <Form.Item label="Hostname" name="outGoingMailServerHostName" labelCol={{ span: 24 }} rules={[
                            {
                              required: true,
                              message: CONFIGURATION_VALIDATIONS?.fieldRequiredMessage,
                            },
                          ]}>
                            <Input type="text" disabled={showEditPrimary} placeholder="Outgoing mail server address"
                              autoComplete="off" required={true} />
                          </Form.Item>
                        </Col><Col>
                          <Form.Item label="Port" name="outGoingMailServerPort" labelCol={{ span: 24 }} rules={[
                            {
                              required: true,
                              message: CONFIGURATION_VALIDATIONS?.fieldRequiredMessage,
                            },
                          ]}>
                            <Input type="text" disabled={showEditPrimary} placeholder="Outgoing server port"
                              autoComplete="off" required={true} />
                          </Form.Item>
                        </Col>
                        <Col md={24}>
                          <Form.Item name="enableSSL" valuePropName="checked">
                            <Checkbox disabled={true}>Enable SSL</Checkbox>
                          </Form.Item>
                        </Col>
                      </Row>
                    </>}
                  </div>
                  {configType === 'microsoftExchange' &&
                    <Row gutter={GUTTOR_SPACE} className="m-l-11">
                      <Col>
                        <Form.Item name="microsoftExchange" labelCol={{ span: 24 }} rules={[
                          {
                            required: true,
                            message: CONFIGURATION_VALIDATIONS?.fieldRequiredMessage,
                          },
                        ]}>
                          <Input
                            key="microsoftExchange"
                            placeholder="Enter Microsoft Exchange URL"
                            addonBefore={
                              <Tooltip title={MICROSOFT_EXCHANGE_URL}>
                                <span>https://</span>
                              </Tooltip>
                            }
                            allowClear={true}
                            disabled={showEditPrimary}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  }
                  <Row gutter={GUTTOR_SPACE} className={configType === OTHER_KEY ? 'other-config' : ''}>
                    {loading ? (
                      <span className={`loader pd-1 ${configType === 'microsoftExchange' ? 'loader-12' : ''}`} />) :
                      showEditPrimary ?
                        <Col>
                          <EditIcon
                            className={configType === 'microsoftExchange' ? 'email-editbtn-primary-ews' : 'email-editbtn-primary'}
                            onClick={(): any => {
                              setIsEditPrimary(false);
                              customGTMEvent({
                                event: 'Edit Primary Email Configuration',
                              });
                            }} />
                        </Col> :
                        <><Col className={`pb-md m-top-4 ${configType === 'microsoftExchange' ? 'padding-l-50' : 'padding-l-24'}`}>
                          <a className="mouse-pointer bold" onClick={(): any => saveHospitalPrimaryId()}>SAVE</a>
                        </Col>
                          <Col onClick={(): any => onCancelHospitalPrimary()} className="pb-md bold color-grey mouse-pointer m-top-4 top-4">
                            CANCEL
                          </Col></>
                    }
                  </Row>
                </Row>
              </Form>
            </Row>
            </>
          }
        </div>
        <div className="flex flex-element flex-col">
          <Row className="w-30 font-weight-text flex flex-element flex-row align-center justify-between">
            <Col md={16}>
              <p className={`m-top-12 font-12 ${isGroupProvidersAvailable() ?
                'disabled-text-color' : ''}`}>Secondary Email ID</p>
            </Col>
            {!showSecondaryEmailField &&
              <Col md={3}>
                <Button type="link" className={isGroupProvidersAvailable() ?
                  'buttontext mouse-pointer-default' : ''} onClick={(): any => { isGroupLogin() && setIsSecondaryShowEmailField(true); }}>
                  <i>Add email</i>
                </Button>
              </Col>
            }
          </Row>
          {showSecondaryEmailField && <span className="secondary-mail-text font-10 secondary-team-text">Enter all email IDs separated by ","
            <br /><i className="secondary-mail-italic-text font-10">
              Secondary email Ids will be used for receiving the mails from the payers</i>
          </span>}
          {showSecondaryEmailField &&
            <div>
              <Form form={secondaryForm} onFinish={saveHospitalSecondaryId}>
                <Row gutter={GUTTOR_SPACE}>
                  <Col md={8} className="no-pdf-l">
                    <FormMultiEmailInput
                      detail={{
                        key: 'secondaryemail',
                        label: 'Secondary Email',
                        placeholder: 'Enter secondary email',
                        hideLabel: true,
                        allowClear: false,
                        className: 'payerEmail-text',
                      }}
                    />
                  </Col>
                  <Col className="pb-md m-top-6">
                    <a className="mouse-pointer bold" onClick={(): any => saveHospitalSecondaryId()}>SAVE</a>
                  </Col><Col onClick={(): any => setInitialSecondaryEmail()} md={2}
                    className="pb-md bold color-grey mouse-pointer m-top-6 top-4">
                    <div>CANCEL</div>
                  </Col>
                </Row>
                <Row className="secondary-mail-custom-tag">
                  {
                    hospSecondaryEmails?.map((email: any, index: any): any =>
                      <CustomTag key={index} text={email} removable={true} onRemove={(): any => onRemoveHospSecondaryEmail(email)} />,
                    )
                  }
                </Row>
              </Form>
            </div>
          }
        </div>
        <div className={`${!hospSecondaryEmails?.length ? 'other-teams' : 'otherDeptFields'} flex flex-element flex-col`}>
          <Row className="w-30 font-weight-text flex flex-element flex-row align-center justify-between">
            <Col md={8}>
              <p className={`font-12 ${(groupProviders?.length && centerId === 0) ? 'center-text' : ''}`}>Other Team</p>
            </Col>
            {!showOtherTeamField &&
              <Col md={3} className="m-top-11">
                <Button type="link" className={isGroupProvidersAvailable() ?
                  'buttontext mouse-pointer-default' : ''}
                  onClick={(): any => { isGroupLogin() && setIsOtherTeamField(true); setIsShowEditDept(true); addHospDept(0); }}>
                  <i>Add email</i>
                </Button>
              </Col>
            }
          </Row>
          {showOtherTeamField &&
            <div className="ml_13">
              <Form form={otherTeamForm}>
                {getOtherTeamEmailRows()}
              </Form>
            </div>
          }
        </div>
      </div >
    </>
  );
};
export default RpaConfiguredPayerList;
